export class AccountStatus {
    code: string;
    name: string;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/models/accountStatus.ts